export default __webpack_public_path__ + "static/media/icon-share-list.c0a6f85f.svg";